import React from "react";
import { PhoneCall, ListTodo, CheckCircle2, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

export const EXTRA = {
  followup: { label: "Follow-up due", chip: "bg-orange-50 border-orange-300 border-l-orange-500", icon: PhoneCall, grad: "from-orange-400 to-amber-500", to: "/followups", hover: "hover:bg-orange-200 text-orange-800" },
  task: { label: "Task due", chip: "bg-green-50 border-green-300 border-l-green-600", icon: ListTodo, grad: "from-green-500 to-emerald-600", to: "/tasks", hover: "hover:bg-green-200 text-green-800" },
};

export const extraDay = (e) => e.kind === "task" ? (e.due_at || "").slice(0, 10) : e.due_date;

export default function ExtraChip({ e, onDone, showRep }) {
  const k = EXTRA[e.kind];
  const Icon = k.icon;
  const done = e.status === "done";
  const id = e.kind === "task" ? e.task_id : e.followup_id;
  const time = e.kind === "task" && e.due_at?.length > 10 ? new Date(e.due_at).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" }) : null;
  return (
    <div draggable={!done} onDragStart={(ev) => { ev.dataTransfer.setData("text/plain", `${e.kind}:${id}`); ev.dataTransfer.effectAllowed = "move"; }}
      className={`group rounded-md border border-dashed border-l-4 border-l-solid px-2 py-1.5 text-xs shadow-sm transition-all ${done ? "bg-slate-100 border-slate-200 border-l-slate-300 opacity-60" : `${k.chip} cursor-grab active:cursor-grabbing hover:shadow-md hover:-translate-y-[1px]`}`}
      data-testid={`extra-chip-${e.kind}-${id}`} title={`${k.label}${e.priority ? ` · ${e.priority} priority` : ""}`}>
      <div className="flex items-start gap-1.5">
        {done ? <CheckCircle2 className="mt-0.5 w-3.5 h-3.5 shrink-0 text-slate-500" /> : <Icon className="mt-0.5 w-3.5 h-3.5 shrink-0 text-slate-700" />}
        <div className="min-w-0 flex-1">
          <div className={`font-semibold truncate text-slate-900 ${done ? "line-through" : ""}`}>{e.title}</div>
          <div className="text-[10px] truncate text-slate-600">{k.label}{time ? ` · ${time}` : ""}{e.facility_name ? ` · ${e.facility_name}` : ""}{showRep && e.assigned_to_name ? ` · ${e.assigned_to_name}` : ""}</div>
        </div>
      </div>
      <div className="mt-1 flex items-center gap-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
        {!done && <button title="Mark done" onClick={() => onDone(e)} className={`p-1 rounded ${k.hover}`} data-testid={`extra-done-${e.kind}-${id}`}><CheckCircle2 className="w-3.5 h-3.5" /></button>}
        <Link to={k.to} title={`Open ${e.kind === "task" ? "Tasks" : "Follow-ups"}`} className="p-1 rounded text-slate-600 hover:bg-white/60" data-testid={`extra-open-${e.kind}-${id}`}><ExternalLink className="w-3.5 h-3.5" /></Link>
      </div>
    </div>
  );
}
